const machine = {
	state : {
        allMachine: {
            page: 1,
            winOffsetY: 0,
            allMachineList: []
        },
        faultMachine: {
            page: 1,
            faultMachineList: []
        },
        nostockMachine: {
            page: 1,
            nostockMachineList: []
        },
        outlineMachine: {
            page: 1,
            outlineMachineList: []
        }
	},

	mutations: {
		GET_MAC: (state,mac) => {
			state.mac = mac;
		}
	}
}

export default machine;


// WEBPACK FOOTER //
// ./src/store/modules/machine.js